import type {Message} from "@repo/guide-types";

export type GuideIconReaction =
    | "blush"
    | "heart"
    | "moved"
    | "starry"
    | "sus"
    | "wink"
    | "thinking";

const reactionMap: Map<string, GuideIconReaction> = new Map([
    ["♥️", "heart"],
    ["❤️", "heart"],
    ["🤩", "starry"],
    ["🥹", "moved"],
    ["🫤", "sus"],
    ["😉", "wink"],
    ["😊", "blush"],
    // This is the horizontal ellipsis character, not three periods.
    // This unique character is used so that thinking will only be
    // triggered by guide actions, not regular Khanmigo messages.
    ["…", "thinking"],
]);

/**
 * This utility is used to map a message to a AI Guide reaction. Used to
 * determine which in-chat reaction animation to display.
 */
export const getGuideIconReaction = (
    message: Message,
): GuideIconReaction | null => {
    // Only display reactions for incoming messages.
    if (message.type !== "incoming") {
        return null;
    }
    for (const emoticon of reactionMap.keys()) {
        if (message.text.includes(emoticon)) {
            return reactionMap.get(emoticon) ?? null;
        }
    }
    return null;
};
